import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./SplitFilter.module.scss";

type SplitValue = "split" | "not_split";

const options: FilterMultiselectOption[] = [
    { value: "split", label: "Split", searchableLabel: "split" },
    { value: "not_split", label: "Not split", searchableLabel: "not split" },
];

export const SplitFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: SplitValue[] = [];
    if (filters.isSplitted) {
        value.push("split");
    }
    if (filters.isNotSplitted) {
        value.push("not_split");
    }

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val as SplitValue[];
                    onChange({
                        isSplitted: selected.includes("split")
                            ? true
                            : undefined,
                        isNotSplitted: selected.includes("not_split")
                            ? true
                            : undefined,
                    });
                }}
                name="split"
                onBlur={noop}
            />
        </div>
    );
};
